import { type KeyValueType } from 'advanced-filters/store/filter';
import { Input } from 'antd';
import { useCallback, useState } from 'react';

function NumberRangeSelectContent({
  initialFromValue,
  initialToValue,
  handleChange,
}: {
  initialFromValue: string;
  initialToValue: string;
  handleChange: (value: KeyValueType) => void;
}) {
  const [fromValue, setFromValue] = useState<string>(initialFromValue || '');
  const [toValue, setToValue] = useState<string>(initialToValue || '');

  const handleSetFromValue = useCallback((val: string) => {
    setFromValue(val);
    handleChange({ value: { from: val, to: toValue } });
  }, [handleChange, setFromValue, toValue]);

  const handleSetToValue = useCallback((val: string) => {
    setToValue(val);
    handleChange({ value: { from: fromValue, to: val } });
  }, [handleChange, fromValue, setToValue]);

  return (
    <>
      <Input
        placeholder="Enter From Value"
        type="number"
        value={fromValue}
        onChange={(e) => handleSetFromValue(e.target.value)}
      />
      <Input
        placeholder="Enter To Value"
        type="number"
        value={toValue}
        onChange={(e) => handleSetToValue(e.target.value)}
      />
    </>
  );
}

export default function NumberRangeSelect({
  value,
  handleChange,
}: {
  value: any;
  handleChange: (value: KeyValueType) => void;
}) {
  let initialFromValue = '';
  let initialToValue = '';

  if (typeof value === 'object' && value !== null) {
    initialFromValue = value.from || '';
    initialToValue = value.to || '';
  }

  return (
    <NumberRangeSelectContent
      initialFromValue={initialFromValue}
      initialToValue={initialToValue}
      handleChange={handleChange}
    />
  );
}
